import styled from 'styled-components';

export const StyledDamagedProductTransactions = styled.div`
  width: 100%;
  overflow: auto;
`;
